import { MobilePlanCardsProductsQuery } from '__generated__/MobilePlanCardsProductsQuery.graphql';

type PlanImages = NonNullable<
  MobilePlanCardsProductsQuery['response']['eligibleProductOffersByCategory']['category']['plans'][0]['planImages']
>[0];
type PlanImageType = PlanImages['type'];

export const getImageByType = (
  images: readonly PlanImages[],
  imageType: PlanImageType,
) => images?.find((image) => image?.type === imageType);

export const getCardImageUrl = (images: readonly PlanImages[]): string => {
  return getImageByType(images, 'FEATURED')?.defaultUrl || '';
};

export const getCardAltText = (images: readonly PlanImages[]): string => {
  return getImageByType(images, 'FEATURED')?.description || 'plan-image';
};
